import React, { Component } from "react";
import $ from "jquery";
import { Consume } from "../../Context/Consumer";
import {
  ConstraintsContext,
  PlayerListContext,
  TransContext,
  PlayerDetailTogglerContext,
  TeamDataContext,
  PlayerCardContext,
} from "../../Context";
import config from "../../common/config";
import { PlayerDetailTogglerProvider } from "../../Context/Providers";
import BottomPlayerDetailsStrip from "./BottomPlayerDetailsStrip";
import {
  makeClasses,
  getTrans,
  setHighlight,
  makeCaptain,
  makeJerseyAnimate,
  setLocalStorage,
  customTracking,
} from "../../common/";
import OutsideNotifier from "../../components/OutsideNotifier";
import { disableBodyScroll } from "body-scroll-lock";

class Jersey extends Component {
  constructor(props) {
    super(props);
    this.playerListToggle.bind(this);
    this.removePlayer.bind(this);
    this.state = {
      showToolTip: false,
    };
  }

  animateView = (objkey) => {
    // makeJerseyAnimate(objkey);
  };

  componentWillUnmount() {
    this.setState({
      showToolTip: false,
    });
  }

  componentWillMount() {
    this.setState({
      showToolTip: false,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.PlayerListData.playerListFilters.priceFilterSelected ==
      "Affordable"
    ) {
      if (prevProps.TeamData.data.budget != this.props.TeamData.data.budget) {
        let budget = this.props.TeamData.data.budget;
        this.props.PlayerListData.setPlayerFilters(
          this.props.PlayerListData.playerListFilters,
          budget
        );
      }
    }
  }

  onJerseyTapToAnimate = (e, objkey) => {
    const tooltipElem = $(e.target).closest(".si-pitch__plyr-box");
    setTimeout(() => {
      this.animateView(objkey);
    }, 300);
  };

  showToolTip = (val) => {
    if (!config.isMobile) {
      this.setState({
        showToolTip: val,
      });
    }
  };

  onJerseyClick = (e, player, objKey, playerIndex) => {
    e.stopPropagation();
    let teamData = this.props.TeamData.data;
    // this.props.PlayerCardData.setPlyActions(false);
    if (window[config.namespaceKey].currentScreen == "/select-captain") {
      /* customTracking(
        "Pick Captain",
        "/" + config.GAME_NAME + "/select-captain/"
      ); */
      if (!this.props.TeamData.data.captainID && config.isMobile) {
        window.scrollTo({
          top: $(".si-pitch__footer")[0].offsetTop,
          left: 0,
          behavior: "smooth",
        });
      }
      let captainSelectedTeamMod = makeCaptain(
        teamData,
        objKey,
        playerIndex,
        player
      );
      this.props.TeamData.setTeamData({ ...captainSelectedTeamMod });
    } else {
      if (player.id == null) {
        // open player listing
        /* customTracking(
          "Tap on Player",
          "/" + config.GAME_NAME + "/create-team/"
        ); */
        if (config.isMobile && this.props.PlayerListData.isPlayerListVisible) {
          this.onJerseyTapToAnimate(e, objKey);
        } else {
          if (config.isMobile) {
            this.props.PlayerListData.togglePlayerList(
              !this.props.PlayerListData.isPlayerListVisible,
              () => {
                this.onJerseyTapToAnimate(e, objKey);
              }
            );
            disableBodyScroll(document.querySelector("body"));
          }
        }

        setHighlight(this.props.TeamData.data, objKey, playerIndex);
        this.props.PlayerListData.playerListFilters.skillId = [player.skill];
        let budget = this.props.TeamData.data.budget;
        this.props.PlayerListData.setPlayerFilters(
          this.props.PlayerListData.playerListFilters,
          budget
        );
      } else {
        //show player card
        this.props.PlayerCardData.setPlayer(player);
        this.props.PlayerCardData.setPlyObjKey(objKey);
        this.props.PlayerCardData.setPlyInx(playerIndex);
        this.props.PlayerCardData.setSpecificData({ showActionButtons: true });
        this.props.PlayerCardData.showHidePlyrCard();
      }
    }
  };

  playerListToggle = (e) => {
    this.props.PlayerListData.togglePlayerList();
  };

  removePlayer = (e, player, objKey, playerIndex) => {
    e.stopPropagation();
    this.setState({
      showToolTip: false,
    });
    // if (config.isMobile) {
    //   this.onJerseyClick(e, player, objKey, playerIndex);
    // } else {
    // }
    this.props.TeamData.addRemovePlayer(player, {}, playerIndex);
  };

  hasSeenTutorialFlag = (val) => {
    setLocalStorage("setHasSeenTutorial", true);
    this.props.TeamData.setHasSeenTutorial(true);
  };

  render() {
    let self = this;
    let { state, props, removePlayer } = self;
    let {
      player,
      TransData,
      TeamData,
      ConstraintsData,
      isBench,
      index,
      objKey,
    } = props;
    let trans = TransData.data;
    const defaultJersey =
      config.IMG_BASE +
      `${""}${"default-jersey"}.png?v=` +
      ConstraintsData?.data?.PlayerJerseyTeamVersion;
    let clickHandler = {};
    if (!TeamData.data) {
      return null;
    }
    let isHighlighted = TeamData.data.highlightedSkill;
    let showHighLight = false;
    if (isHighlighted) {
      if (
        isHighlighted.rowIndex == objKey &&
        this.props.index == isHighlighted.playerIndex
      ) {
        showHighLight = true;
      }
    }
    let isCaptainScreen =
      window[config.namespaceKey].currentScreen == "/select-captain" ||
      window[config.namespaceKey].currentScreen == "/save-team"
        ? true
        : false;
    let saveTeamPage =
      window[config.namespaceKey].currentScreen == "/save-team";

    // const isFixtureUpdated = (IsFixtureUpdated === 1 || IsFixtureUpdated === "1");
    // const isLast = this.props.position;
    const playerIndex = this.props.index;

    let showFirstTimeOption = this.props.TeamData.hasSeenTutorial
      ? false
      : true;

    const tutorialTooltip = (
      <OutsideNotifier handler={this.hasSeenTutorialFlag.bind(this)}>
        <div className="si-tooltip ">
          {getTrans(trans, "pick_your", "Pick your player")}
        </div>
      </OutsideNotifier>
    );
    let { isCaptain } = player;

    if (player.id === null) {
      clickHandler = {
        onClick: (e) => {
          this.onJerseyClick(e, player, objKey, playerIndex);
        },
      };
      let jerseyClassName = makeClasses({
        "si-pitch__plyr": true,
        "si-add": true,
        "si-tutorial": showFirstTimeOption && showHighLight,
        "si-injury":
          player.details.PlayerStatus === config.enumPlayerStatus.Injured,
        "si-suspended":
          player.details.PlayerStatus === config.enumPlayerStatus.Suspended,
        "si-doubtful":
          player.details.PlayerStatus === config.enumPlayerStatus.Doubtful,
      });
      return (
        <div className="si-pitch__plyr si-add" {...clickHandler}>
          <div className="si-pitch__plyr-box">
            <div className="si-btn__adRe"></div>
            <div
              className="si-pitch__plyr-thumb"
              style={{
                backgroundImage: `url(${config.IMG_BASE}default_jersey.svg?v=${ConstraintsData?.data?.PlayerJerseyTeamVersion})`,
              }}
            >
              {" "}
            </div>
            <div className="si-pitch__plyr-name">
              <span>
                {getTrans(
                  this.props.TransData.data,
                  config.positionMap[player.skill].skillShortTrans,
                  config.positionMap[player.skill].key
                )}
              </span>
            </div>
            <div className="si-pitch__plyr-num">
              <span>00</span>
            </div>
          </div>
        </div>
      );
    } else {
      let jerseyClassName = makeClasses({
        "si-pitch__plyr": true,
        // "si-selected": true,
        "si-remove": true,
        "si-cap": isCaptain,
        "si-injury":
          player.details.PlayerStatus === config.enumPlayerStatus.Injured,
        "si-suspended":
          player.details.PlayerStatus === config.enumPlayerStatus.Suspended,
        "si-doubtful":
          player.details.PlayerStatus === config.enumPlayerStatus.Doubtful,
        "si-bonus": player?.details?.IsBonus,
      });
      clickHandler = {
        onClick: (e) => {
          this.onJerseyClick(e, player, objKey, playerIndex);
        },
      };
      let playerValueText =
        config.language === config.lang.English ? (
          <span>
            {Math.round(player.details.Value * 100) / 100}{" "}
            <em>{getTrans(trans, "M", "M")}</em>
          </span>
        ) : (
          <span>
            {Math.round(player.details.Value * 100) / 100}{" "}
            <em>{getTrans(trans, "M", "M")}</em>
          </span>
        );
      const teamImg =
        config.playerImgBase +
        `player-jersey/${player.details.Skill === 1 ? "GK/" : ""}${
          player.details["TeamId"]
        }.png?v=` +
        ConstraintsData?.data?.PlayerJerseyTeamVersion;
      return (
        <div className={jerseyClassName} {...clickHandler}>
          {/* <!-- si-add | si-remove | si-cap | si-live | si-pts | si-subs | si-unavailable | si-doubtful | si-suspended | si-injury --> */}
          <div className="si-pitch__plyr-box">
            <div
              className="si-btn__adRe"
              onClick={(e) =>
                removePlayer(e, player.details, objKey, playerIndex)
              }
            ></div>
            <div
              className="si-pitch__plyr-thumb"
              style={{
                backgroundImage: `url(${config.IMG_BASE}jerseys/${player.details.TeamId}.png?v=${ConstraintsData?.data?.PlayerJerseyTeamVersion})`,
              }}
            ></div>
            <div className="si-pitch__plyr-name">
              <span>{player.details.DisplayName}</span>
            </div>
            <div className="si-pitch__plyr-num">{playerValueText}</div>
          </div>
        </div>
      );
    }
  }
}

export default Consume(Jersey, [
  ConstraintsContext,
  PlayerListContext,
  TransContext,
  PlayerDetailTogglerContext,
  TeamDataContext,
  PlayerCardContext,
]);
